import { useSessionData } from '@confluence/session-data';

import { expValEquals } from '@confluence/feature-experiments';
import { useIsNav4Enabled } from '@confluence/nav4-enabled';

import { ConfluenceEdition } from '../Upgrade/__types__/waitForEditionChangeQuery';

export const useIsContentManagerUpsellEnabled = () => {
	const { edition } = useSessionData();
	const isNav4Enabled = useIsNav4Enabled();

	if (!isNav4Enabled || edition === ConfluenceEdition.PREMIUM) return false;
	if (expValEquals('confluence_analytics_content_manager_upsell_flag', 'cohort', 'experiment'))
		return true;
	return false;
};
